<template>
  <v-form ref="form">
    <v-container>
      <v-row>
        <v-col cols="12" md="6" sm="6">
          <div>
            <v-file-input
              ref="inputFile"
              :error-messages="errors.work_image"
              v-model="data.work_image"
              accept="application/pdf, image/png, image/jpeg, image/jpg"
              prepend-icon="mdi-cloud-upload"
              label="upload the work"
              solo
              id="upload"
              @change="imageConvert()"
            >
            </v-file-input>
            <span class="text-caption pl-7">Support files pdf, image/png, image/jpeg, image/jpg</span>
            
            <v-progress-linear
              v-if="percentage"
              v-model="uploadPercentage"
              color="blue-grey"
              height="20"
            >
              <template v-slot:default="{ value }">
                <strong>{{ Math.ceil(value) }}%</strong>
              </template>
            </v-progress-linear>
          </div>
          <div>
            <img id="input" style="display:none" />
          </div>
          <div>
            <img id="output" style="display:none" />
          </div>
        </v-col>

        <v-col cols="12" md="6" sm="6">
          <div>
            <v-select
              solo
              :items="items"
              :item-text="getFieldText"
              :error-messages="errors.tutor_id"
              item-value="tutor_id"
              label="Select Tutor"
              v-model="data.tutor_id"
            ></v-select>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn color="#6A158E" @click="save()" large dark>Save</v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar v-model="snackbar" top right color="success" v-if="snackbar">
      {{ snackbarMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false"
          >X</v-btn
        >
      </template>
    </v-snackbar>
  </v-form>
</template>

<script>
import { bus } from "../../main";

export default {
  name: "uploadWork",
  data() {
    return {
      skill: 20,
      errors: {},
      items: [],
      percentage: false,
      snackbarMessage: "",
      snackbar: false,
      uploadPercentage: 0,
      data: {
        workImage: "",
        tutor_id: "",
        work_image: null,
        fileType: null,
      },
    };
  },
  methods: {
    getFieldText(item) {
      return `${item.tutor_fname} - ${item.tutor_lname}`;
    },
    imageConvert(e) {
      console.log("File/Image: ", event.target.files[0]);
      this.data.work_image = event.target.files[0];
      console.log("File/Image Size: ", this.data.work_image.size);
    },

    save() {
      this.percentage = true;
      let formData = new FormData();

      this.data.fileType = this.data.work_image.type;

      formData.append("work_image", this.data.work_image);
      formData.append("tutor_id", this.data.tutor_id);
      formData.append("file_type", this.data.fileType);

      axios
        .post(apiRoutes.UploadWork.uploadwork, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },

          onUploadProgress: function(progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })

        .then((response) => {
          this.errors = {};
          this.percentage = false;
          bus.$emit("workUpload");
          this.snackbar = true;
          this.snackbarMessage = response.data.message;
          this.$refs.form.reset();
          this.$refs.inputFile.reset();
          this.uploadPercentage = 0;
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.uploadPercentage = 0;
            this.percentage = false;
            this.errors = error.response.data.errors;
          }
        });
    },

    getItems() {
      axios.get(apiRoutes.UploadWork.url).then((response) => {
        this.items = response.data.response;
        this.loading = false;
      });
    },
  },
  mounted() {
    this.getItems();
  },
};
</script>
